import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from 'chart.js';
import { useSelector } from 'react-redux';
import { getTotalInfluencer } from 'features/influencer/actions';
import CardDashboard from './dashboard-item';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, ArcElement);

export const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
  },
};

const InfluencerStats = () => {
  const { influencer, isLoading } = useSelector((state) => state.influencerStats);

  const totalInfluencer = (influencer?.active || 0) + (influencer?.inactive || 0);

  const data = {
    labels: ['Aktif', 'Tidak Aktif'],
    datasets: [
      {
        tension: 0.2,
        data: [influencer?.active || 0, influencer?.inactive || 0],
        backgroundColor: ['rgba(0, 158, 247,1)', 'rgba(1, 106, 164, 1)', 'rgba(0, 0, 0, 0.2)'],
        borderRadius: 6,
      },
    ],
  };

  return (
    <div className="influencer-stats">
      <CardDashboard
        title="Jumlah Influencer"
        value={totalInfluencer}
        asChild
        filter
        filterAction={getTotalInfluencer}
        isLoading={isLoading}
      >
        <div className="chart">
          <Doughnut options={options} data={data} height={117} width={130} />
        </div>
        <ul className="value-wrapper">
          {data.labels.map((item, idx) => (
            <li key={idx}>
              <div style={{ background: `${data.datasets[0].backgroundColor[idx]}` }} />
              <div className="percentage">
                <span>{item}</span>
                <span className="value">
                  {data.datasets[0].data[idx] > 0
                    ? `${Math.round((data.datasets[0].data[idx] / totalInfluencer) * 100)}%`
                    : '0%'}
                </span>
              </div>
            </li>
          ))}
        </ul>
      </CardDashboard>
    </div>
  );
};

export default InfluencerStats;
